(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-finish-floor]').forEach((root) => {
      if (root.dataset.finishReady) return;
      root.dataset.finishReady = 'true';
      root.querySelectorAll('[data-finish-card]').forEach((card) => {
        const choice = card.querySelector('[data-finish-variant]');
        const quantity = card.querySelector('[data-finish-quantity]');
        const form = card.querySelector('form');
        const button = form.querySelector('[type="submit"]');
        const unit = card.querySelector('[data-finish-unit]');
        const total = card.querySelector('[data-finish-total]');
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: card.dataset.currency || 'USD'
        });
        const option = () => choice.tagName === 'SELECT' ? choice.selectedOptions[0] : choice;
        const update = (changed = false) => {
          const selected = option();
          const price = Number(selected?.dataset.price);
          quantity.min = selected?.dataset.min || '1';
          quantity.step = selected?.dataset.step || '1';
          if (selected?.dataset.max) quantity.max = selected.dataset.max;
          else quantity.removeAttribute('max');
          if (changed && !quantity.validity.valid) quantity.value = quantity.min;
          const valid = Number.isFinite(price) && price > 0;
          button.disabled = !valid;
          unit.textContent = valid ? formatter.format(price / 100) : '—';
          total.textContent = valid && quantity.validity.valid ? formatter.format(price * Number(quantity.value) / 100) : '—';
        };
        form.addEventListener('submit', (event) => {
          if (root.hidden || !form.reportValidity() || button.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
        choice.addEventListener('change', () => update(true));
        quantity.addEventListener('input', () => update());
        quantity.addEventListener('change', () => update());
        update();
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!root.isConnected) { unsubscribe(); return; }
          if (data.sectionId !== root.dataset.floorSection) return;
          root.hidden = !data.variant || !data.variant.available || /sample/i.test(data.variant.title);
        });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
